import { Injectable, Type } from '@angular/core';
import { GameRecord, ConfigurationItem, NetworkConstants, HuntingDistrict, HuntingEvent } from 'diwimamodelweb/lib';
import { BehaviorSubject } from 'rxjs';
import { GamerecordService } from 'src/app/shared/gamerecord.service';
import { DateFilter, DateFilterOption, Filter, FilterEqual, filterObjects } from 'diwimamodelweb/lib/utils/filter'
import { SettingsService } from 'src/app/shared/settings.service';
import { TranslateService } from '@ngx-translate/core';
import { skipWhile, take } from 'rxjs/operators';
import { GamerecordStatisticsService } from './gamerecord-statistics.service';
import { HuntingDistrictService } from 'src/app/shared/hunting-district.service';
import { MultiSelectDialogComponent } from './multi-select-dialog/multi-select-dialog.component';
import { SingleSelectDialogComponent } from './single-select-dialog/single-select-dialog.component';
import { EventsService } from 'src/app/shared/events.service';
import { DateRangeSelectDialogComponent } from 'src/app/cockpit/dashboard/date-range-select-dialog/date-range-select-dialog.component';
import { GrMultiSelectFilterDialogComponent } from 'src/app/cockpit/dashboard/gr-multi-select-filter-dialog/gr-multi-select-filter-dialog.component'


export interface FilterItemCallback {
  onFilterItemSelected: (item: FilterSelectItem) => void
  onFilterItemDeselected: (item: FilterSelectItem) => void
  onActiveFiltersChanged: (activeFilters: Filter[]) => void
}

/**
 * Function that returns the start and end Dates of the current hunting season 
 * in Germany this is 01.04.x -> 31.03.x + 1
 * 
 * @returns {start: Date, end: Date}
 */
export const getCurrentJagdJahr = (): {start: Date, end: Date} => {
  const startString = `-04-01T00:00:00`
  const endString = `-03-31T23:59:59`
  const now = new Date()
  const year = now.getFullYear()  // eg. 2021
  const month = now.getMonth()    // 0-11
  if (month < 3) {
    // meaning start in last year
    return {start: new Date(`${year - 1}${startString}`), end: new Date(`${year}${endString}`)}
  } else {
    return {start: new Date(`${year}${startString}`), end: new Date(`${year + 1}${endString}`)}
  }
}

/**
 * Function that returns the start and end Dates of the previous hunting season 
 * in Germany this is 01.04.x -> 31.03.x + 1
 * 
 * @returns {start: Date, end: Date}
 */
 export const getPreviousJagdJahr = (): {start: Date, end: Date} => {
  const startString = `-04-01T00:00:00`
  const endString = `-03-31T23:59:59`
  const now = new Date()
  const year = now.getFullYear()  // eg. 2021
  const month = now.getMonth()    // 0-11
  if (month < 3) {
    // meaning start in last year
    return {start: new Date(`${year - 2}${startString}`), end: new Date(`${year - 1}${endString}`)}
  } else {
    return {start: new Date(`${year - 1}${startString}`), end: new Date(`${year}${endString}`)}
  }

}

export class FilterSelectItem {
  
  public activeFilters: Map<string, Filter> = new Map()
  public listeners: any[] = []

  //public componentRef: Type<any> = MultiSelectDialogComponent
  public componentRef: Type<any> =  GrMultiSelectFilterDialogComponent
  constructor(
    public settingId: string,
    public title: string,
    public filterCallback: ((filter: Filter[]) => void),
    public options?: [{selected: boolean, item: ConfigurationItem, optionGroup?:string}],
    public sortOrder?: Number,
    public optionsGroups?:string[]
  ) {
    options?.forEach(element => {
      if (element.selected && element.item) {
        this.buildFilter(settingId, element.item)
      }
    });
    if (settingId == "timeStamp") this.componentRef = DateRangeSelectDialogComponent
    //if (settingId == "timeStamp") this.componentRef = SingleSelectDialogComponent
  }

  deselectFilter(identifier) {
    delete this.activeFilters[identifier]
  }
  setActiveFilter(selectedOptions: [{selected: boolean, item: ConfigurationItem, optionGroup?:string}], group?:string) {
    this.activeFilters.clear()
    const identifierList = selectedOptions.map(el => el.item?.identifier)
    this.options.forEach((option) => {
      if (identifierList.includes(option.item.identifier)){
        if(!option.selected) {
          option.selected = true
        }
        this.buildFilter(this.settingId, option.item)
      } else {
        option.selected = false
        this.deselectFilter(option.item.identifier)
      }
    })
    this.onFilter()
  }

  setUnselectedAllActiveFilter(selectedOptions: [{selected: boolean, item: ConfigurationItem, optionGroup?:string}], group?:string) {
    this.activeFilters.clear()
    const identifierList = selectedOptions.map(el => el.item?.identifier)
    this.options.forEach((option) => {
      if(option.item?.optionGroup == group){
        option.selected = false
        this.deselectFilter(option.item.identifier)
      }else{
        if (identifierList.includes(option.item.identifier)){ // if its not from the group and its selected --> build filter
          if(!option.selected) {
            option.selected = true
          }
          this.buildFilter(this.settingId, option.item)
        } else { // if is not on the group and not selected --> deselect filter
          option.selected = false
          this.deselectFilter(option.item.identifier)
        }
      }
    })
    this.onFilter()
  }

  setSelectAllActiveFilter(listOptions: [{selected: boolean, item: ConfigurationItem, optionGroup?:string}], group?:string) {
    this.activeFilters.clear()
    const selectedItems = listOptions.filter(el => el.selected).map(el => el.item?.identifier)
    this.options.forEach((option, index) => {
      if (group){
        if(option.item?.optionGroup && option.item?.optionGroup == group){
            option.selected = true
            this.buildFilter(this.settingId, option.item)
        }else{// if not on the group
          if (selectedItems.includes(option.item.identifier)){// list of all selected options
            if(!option.selected) {
              option.selected = true
            }
            this.buildFilter(this.settingId, option.item)
          } else {
            option.selected = false
            this.deselectFilter(option.item.identifier)
          }
        }
      }else{
        // if(!allOptionsSelected){
          if(!option.selected) {
            option.selected = true
          }
          this.buildFilter(this.settingId, option.item)

        // }else{
        //   option.selected = false
        //   this.deselectFilter(option.item.identifier)
        // }
      }

    })
    this.onFilter()
  }

  buildFilter(settingId: string, option: any) {
    switch(settingId) {
      case(NetworkConstants.SETTING_SPECIES): {
        this.activeFilters.set(option.identifier,
          new FilterEqual(
            `${settingId}_${option.identifier}`,
            'wildart',
            option.identifier
          )
        )
        break
      }
      case(NetworkConstants.SETTING_HUNTING_METHODS): {
       this.activeFilters.set(option.identifier,
         new FilterEqual(
           `${settingId}_${option.identifier}`,
           'erlegeArt',
           option.identifier
          )
        )
        break
      }
      case(NetworkConstants.SETTING_GR_LOCATION): {
        this.activeFilters.set(option.identifier,
          new FilterEqual(
            `${settingId}_${option.identifier}`,
            'currentLocationID',
            option.identifier
          )
        )
        break
      }
      case(NetworkConstants.SETTING_GR_STATUS): {
        this.activeFilters.set(option.identifier,
          new FilterEqual(
            `${settingId}_${option.identifier}`,
            'status',
            option.identifier
          )
        )
        break
      }
      case(NetworkConstants.SETTING_GR_MEAT_QUALITY): {
        this.activeFilters.set(option.identifier,
          new FilterEqual(
            `${settingId}_${option.identifier}`,
            'meatQuality',
            option.identifier
          )
        )
        break
      }
      case(NetworkConstants.SETTING_GR_SHOT_QUALITY): {
        this.activeFilters.set(option.identifier,
          new FilterEqual(
            `${settingId}_${option.identifier}`,
            'shotQuality',
            option.identifier
          )
        )
        break
      }
      case("huntingDistrict"): {
        if(option.reportId){
          const newFilter = new FilterEqual(
              `huntingDistrict_${option.identifier}`,
              'huntingDistrictId',
              option.identifier
            )
            newFilter.filterCheckExtraFiled = [{key:'reportingIds', value:option.reportId , type:'array'}]
          this.activeFilters.set(option.identifier,newFilter)
        }else{
          this.activeFilters.set(option.identifier,
            new FilterEqual(
              `huntingDistrict_${option.identifier}`,
              'huntingDistrictId',
              option.identifier
            )
          )
        }
        
        break
      }
      case("huntingEvent"): {
        this.activeFilters.set(option.identifier,
          new FilterEqual(
            `huntingEvent${option.identifier}`,
            'eventId',
            option.identifier
          )
        )
        break
      }
      case("timeStamp"): {
        const dateFilter = new DateFilter(
          `timeStamp_${option.identifier}`,
          'timeStamp',
          option.dateFilterOption,
          option.filterValue
        )
        // this.componentRef = SingleSelectDialogComponent
        this.activeFilters.set(option.identifier,
          dateFilter
        )
        break
      }
    }
  }

  onFilter() {
    this.onActiveFiltersChanged()
    this.filterCallback([...this.activeFilters.values()])
  }

  onFilterItemSelected() {
    this.listeners.forEach((listener) => {
      listener.onFilterItemSelected(this)
    })
  };
  onFilterItemDeselected() {
    this.options.forEach(el => el.selected = false)
    this.listeners.forEach((listener) => {
      listener.onFilterItemDeselected(this)
    })
  }
  onActiveFiltersChanged() {
    this.listeners.forEach((listener) => {
      listener.onActiveFiltersChanged([...this.activeFilters.values()])
    })
  }
}

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  chartColors:any={}

  //----->statistics filters
  availableFilter$ = new BehaviorSubject<Map<string, FilterSelectItem>>(new Map())
  selectedFilterItem$ = new BehaviorSubject<FilterSelectItem[]>([])

  // originalGameRecords$ = new BehaviorSubject<GameRecord[]>(undefined)
  filteredGameRecords$ = new BehaviorSubject<GameRecord[]>(undefined)
  allGameRecords$= new BehaviorSubject<GameRecord[]>(undefined)

  constructor(
    private gameRecordService: GamerecordService,
    private settingsService: SettingsService,
    private translateService: TranslateService,
    private gamerecordStatisticsService: GamerecordStatisticsService,
    private huntingDistrictService: HuntingDistrictService,
    private eventsService: EventsService
  ) {
    this.settingsService.selectedUserContext$.subscribe((sel) => {
      if (!sel) {
        // reset values
        this.availableFilter$.next(new Map())
        this.selectedFilterItem$.next([])
      }else{
        this.selectedFilterItem$.next([])
        this.availableFilter$.next(new Map())
        this.loadTimeStampFilter()
        if(sel.identifier === this.settingsService.lastContextSelected$.value){
          this.loadSettingsData('filter_species', this.settingsService.settingSpecies.value, 1)
          this.loadSettingsData('filter_huntingMethod', this.settingsService.settingHuntingMethods.value, 3)
          this.loadSettingsData('filter_location', this.settingsService.settingsGameLocations.value, 2)
          this.loadSettingsData('filter_status', this.settingsService.settingsGameStatus.value, 3)
          this.loadSettingsData('filter_meat_qulities', this.settingsService.settingMeatQualitySubject.value, 4)
          this.loadSettingsData('filter_shot_qualities', this.settingsService.settingShotQualitySubject.value, 5)
        }
      }
    })
    this.settingsService.settingSpecies.subscribe(async (setting) => {
      this.loadSettingsData('filter_species', setting, 1)
    })
    this.settingsService.settingHuntingMethods.subscribe(async (setting) => {
      this.loadSettingsData('filter_huntingMethod', setting, 3)
    })
    this.settingsService.settingsGameLocations.subscribe(async (setting) => {
      this.loadSettingsData('filter_location', setting, 2)
    })
    this.settingsService.settingsGameStatus.subscribe(async (setting) => {
      this.loadSettingsData('filter_status', setting, 3)
    })
    this.settingsService.settingMeatQualitySubject.subscribe(async (setting) => {
      this.loadSettingsData('filter_meat_qulities', setting, 4)
    })
    this.settingsService.settingShotQualitySubject.subscribe(async (setting) => {
      this.loadSettingsData('filter_shot_qualities', setting, 5)
    })
    this.huntingDistrictService.huntindDistrictSubject$.subscribe(async (districts: HuntingDistrict[]) => {
      if (!districts || districts.length == 0) return 
      const title = await this.translateService.instant('filter_hunting_district')
      const values = districts.map(d => {return {identifier: d.identifier, title: d.name, optionGroup:'ownDistrict'}})

      const reportingValues = this.getReportingDistrictsFromContext()
      const allDistricts = values.concat(reportingValues)
      this.setAvailabeFilter(title, "huntingDistrict", allDistricts, 6)
    });
    this.eventsService.eventsSubject$.subscribe(async (events: HuntingEvent[]) => {
      if (!events || events.length == 0) return 
      const title = await this.translateService.instant('filter_hunting_event')
      const values = events.map(d => {return {identifier: d.identifier, title: d.name}})
      this.setAvailabeFilter(title, "huntingEvent", values, 7)
    });

    
    (async () => {
      this.loadTimeStampFilter()
    }) ();


    this.gamerecordStatisticsService.allGameRecords$.pipe(
      skipWhile(el => !el),
      // take(1)
    ).subscribe((records) => {
      this.filteredGameRecords$.next(records)
      this.filter()
    })
    
    this.gameRecordService.allGameRecordsSubject$.pipe(skipWhile(el => !el)).subscribe({
      next: (records: GameRecord[]) => {
        records?.forEach(el => {
          if (el.huntingDistrictId && !el.huntingDistrictName) {
            el.huntingDistrictName = this.huntingDistrictService.huntindDistrictSubject$.value?.find(e => e.identifier == el.huntingDistrictId)?.name
          }
        })
        this.filteredGameRecords$.next(records)
        this.filter()
        // this.dataSource = new MatTableDataSource(records)
        // this.filterGameRecordService.setfilteredGameRecord(records)
        // this.dataSource.paginator = this.paginator
        // this.dataSource.sort = this.sort
        // this.show = true
        // this.dataSourceForExcelExport = new MatTableDataSource(records)
      },
      error: (error) => {
        console.error(error)
      }
    })

  }


  async loadSettingsData(translate, setting, sortOrder){
    if (!setting) return
    const title = await this.translateService.instant(translate)
    this.setAvailabeFilter(title, setting.identifier, setting.values, sortOrder)
  }

  async loadTimeStampFilter(){
    const dateRangeItemTitles = await this.translateService.instant('filter_date_range_items')
      const currentHuntingYear = getCurrentJagdJahr()
      const previousHuntingYear = getPreviousJagdJahr()
      const options = [
                {
          identifier: "today",
          title: dateRangeItemTitles["today"],
          dateFilterOption: DateFilterOption.AFTER,
          filterValue: {baseValue: new Date(new Date().setHours(0,0,0,0) )}
          // filterValue: {baseValue: new Date(new Date()), firstHour: new Date(new Date().setHours(0,0,0,0) )}
        },
        {
          identifier: "last_7_days",
          title: dateRangeItemTitles["last_7_days"],
          dateFilterOption: DateFilterOption.AFTER,
          filterValue: {baseValue: new Date(new Date().setDate(new Date().getDate() -7 ))}
        },
        {
          identifier: "last_30_days",
          title: dateRangeItemTitles["last_30_days"],
          dateFilterOption: DateFilterOption.AFTER,
          filterValue: {baseValue: new Date(new Date().setDate(new Date().getDate() -30 ))}
        },
        {
          identifier: "current_year",
          title: dateRangeItemTitles["current_year"],
          dateFilterOption: DateFilterOption.AFTER,
          filterValue: {baseValue: currentHuntingYear.start}
        },
        {
          identifier: "last_year",
          title: dateRangeItemTitles["last_year"],
          dateFilterOption: DateFilterOption.BETWEEN,
          filterValue: {startDate: previousHuntingYear.start, endDate: previousHuntingYear.end}
        },
        {
          identifier: "custom",
          title: dateRangeItemTitles["custom"],
          dateFilterOption: DateFilterOption.BETWEEN,
          filterValue: {startDate: previousHuntingYear.start, endDate: previousHuntingYear.end}
        }
      ]
      const filterDateRangeTitle = await this.translateService.instant('filter_date_range')
      this.setAvailabeFilter(filterDateRangeTitle, "timeStamp", options, 7)
  }

  getReportingDistrictsFromContext(){
    const n = this.translateService.instant('my_data')
    const sorted = this.settingsService.allReportingContexts$.value?.sort((a, b) => a.huntingDistrictName < b.huntingDistrictName ? -1 : 1)
    
    // set them active by Default
    const myData = {
      identifier: "IST_EH_EGAL",
      huntingDistrictName: n
    }

    const reportingContexts$ = this.settingsService.allReportingContexts$
    const reportingData = reportingContexts$.value


    const values = reportingData?.map(d => {return {identifier: d.huntingDistrictId, title: d.huntingDistrictName,reportId:d.identifier, optionGroup:'reportingDistrict'}})
    return values
  }

  addFilterItem(filter: FilterSelectItem) {
    let allFilters = this.selectedFilterItem$.value
    const ind = allFilters?.findIndex(el => el.settingId == filter.settingId)
    if (ind != -1) return
    if (!allFilters) allFilters = []
    allFilters.push(filter)
    this.selectedFilterItem$.next(allFilters)
    filter.onFilterItemSelected()
  }

  removeFilterItem(filter: FilterSelectItem) {
    let allFilters = this.selectedFilterItem$.value
    const ind = allFilters.findIndex(el => el.settingId == filter.settingId)
    if (ind != -1) allFilters.splice(ind, 1)
    else return 
    this.selectedFilterItem$.next(allFilters)
    if (allFilters.length > 0) {
      let filters = []
      allFilters.forEach((item) => {
        filters = filters.concat([...item.activeFilters.values()])
      })
      this.filter()
    } else {
      this.filter()
    }
    filter.onFilterItemDeselected()
  }

  private setAvailabeFilter(title: string, key: string, options: any[], sortOrder: Number) {
    const availabeFilter = this.availableFilter$.value
    let opts: any = []
    options.forEach((item) => {
      if(key == "huntingDistrict"){
        if(item)
        opts.push({selected: true, item})//uncomment for default filter: select all by default
        // if(item.optionGroup=="reportingDistrict"){
        //   opts.push({selected: true, item})
        // }else{
        //   opts.push({selected: false, item})
        // }
      }
      ///////---- uncomment for default filter: Current year
      if( key == "timeStamp" ){
      if(item.identifier =='current_year'){
        opts.push({selected: true, item})
      }else
      opts.push({selected: false, item})
      }

      if( key != "timeStamp" && key != "huntingDistrict"){
        opts.push({selected: false, item})
      }
    })
    availabeFilter.set(key, 
      new FilterSelectItem(
        key,
        title,
        (filter: Filter[]) => {
          this.filter()
        },
        opts,
        sortOrder
      )
    )

    //default filters
    availabeFilter.forEach( filter=> {
    ///////---- uncomment for default filter: Current year
      if( filter.settingId=="timeStamp")
        this.addFilterItem(filter)

      ///////---- uncomment for default filter: context reporting Hunting Districts active
      if(filter.settingId=="huntingDistrict"){
        filter.optionsGroups = ['ownDistrict', 'reportingDistrict']
        this.addFilterItem(filter)
      }
      this.filter()
    })
    this.availableFilter$.next(availabeFilter)
  }

  filter() {  
    if (this.selectedFilterItem$.value.length > 0) {
      const fl = this.selectedFilterItem$.value.filter( el => el.activeFilters.size != 0)// added filter to prevent filtering when unselect all options
                .map(el => [...el.activeFilters.values()])
      const data = filterObjects(this.gamerecordStatisticsService.allGameRecords$.value, fl)
      // const data = filterObjects(this.gameRecordService.allGameRecordsSubject$.value, fl)
      this.filteredGameRecords$.next(data)
    } else {
      this.filteredGameRecords$.next(this.gamerecordStatisticsService.allGameRecords$.value)
      // this.filteredGameRecords$.next(this.gameRecordService.allGameRecordsSubject$.value)
    }
  }

  setChartColors( specie, color){
    this.chartColors[specie.species]=color
  }

  getChartColors( specie){
    return this.chartColors[specie]
  }

  getChartColorsAll( ){
    return this.chartColors
  }
}
